import { render } from "./ProsesAgenda.vue?vue&type=template&id=364524dd"
import script from "./ProsesAgenda.vue?vue&type=script&lang=js"
export * from "./ProsesAgenda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__